import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import PrimaryButton from "../../elements/primary-button";
import "./style.scss";
import config from "../../temp/config";
import siteApi from "../../utils/siteApi";

export default function OverviewPromoFinalizeOrder({ button, overviewHeading, overviewBody, heading, membershipPlanCode, orderMarket, orderLang, orderOrgId, orderDetailRes, membershipCode, orderNo }) {
  const [linkHref, setLinkHref] = useState();
  const [marketOrderMadeOn, setMarketOrderMadeOn] = useState();

  useEffect(() => {
    init();
  }, [orderMarket, orderLang]);

  const init = async () => {
    let _linkHref = button?.link?.value?.href;
    const currentMarket = _linkHref?.split("/")[1];

    let _marketOrderMadeOn = marketOrderMadeOn;
    if (!_marketOrderMadeOn) {
      if (membershipPlanCode === "month-to-month" && orderMarket && orderLang) {
        _marketOrderMadeOn = `${orderLang?.toLowerCase()}-${orderMarket?.toLowerCase()}`;
      } else if (membershipPlanCode === "buy-a-car") {
        let {
          Data: { CountryOrg }
        } = await siteApi.siteByOrgId.get({
          key: orderOrgId
        });
        _marketOrderMadeOn = CountryOrg;
      }
      setMarketOrderMadeOn(_marketOrderMadeOn);
    }

    if (currentMarket != _marketOrderMadeOn && config.webSettings.languages.includes(_marketOrderMadeOn)) {
      _linkHref = _linkHref?.replace(currentMarket, _marketOrderMadeOn);
    }

    if (membershipPlanCode) {
      _linkHref = `${_linkHref}/--/${membershipPlanCode}`;
      if (orderNo) {
        _linkHref = `${_linkHref}?relatedOrderNo=${orderNo}`;
      }
    }
    if (orderDetailRes && orderDetailRes?.usePageName === "history") {
      const language = orderMarket ? `${orderLang?.toLowerCase()}-${orderMarket?.toLowerCase()}` : orderLang?.toLowerCase();
      _linkHref = _linkHref?.replace(currentMarket, language);
      _linkHref = `${_linkHref}?lid=${orderDetailRes?.id}&lno=${orderDetailRes?.orderNo}`;
    }

    setLinkHref(_linkHref);
  };

  /** Measurement */
  const measurementHandler = () => {
    let dataLayer = window.dataLayer || [];

    let member_level = "";

    switch (membershipCode) {
      case "MEMBERSHIP02":
        member_level = "level1";
        break;
      case "MEMBERSHIP03":
        member_level = "level2";
        break;
      case "MEMBERSHIP04":
        member_level = "level3";
        break;
    }
    dataLayer.push({
      event: "finalizeOrderPreSales",
      eventCategory: "pre sales",
      eventAction: "finalize order",
      eventLabel: member_level
    });
  };

  let buttonProp = {
    ...button,
    link: {
      ...button?.link,
      value: {
        ...button?.link?.value,
        href: linkHref
      }
    },

    callback: event => measurementHandler(event)
  };
  if (!overviewHeading?.value || !overviewBody?.value) {
    return <></>;
  } else {
    return (
      <div className="overview-promo-finalize-order">
        {heading && heading?.html.value && (
          <div className="overview-promo-finalize-order-heading">
            <Heading {...heading} typographyClass="type-h3" />
          </div>
        )}
        <div className="overview-promo-finalize-order-container">
          <BodyText html={overviewHeading} className={"overview-promo-finalize-order-heading"} />
          <BodyText html={overviewBody} className={"overview-promo-finalize-order-body"} />
          <div>
            <PrimaryButton
              {...{
                ...buttonProp
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

OverviewPromoFinalizeOrder.propTypes = {
  heading: PropTypes.shape({
    type: PropTypes.object,
    className: PropTypes.string,
    /** This takes the component is RTF */
    html: PropTypes.object
  }),
  overviewHeading: PropTypes.object,
  overviewBody: PropTypes.object,
  button: PropTypes.shape({
    callback: PropTypes.func,
    icon: PropTypes.shape({ svg: PropTypes.string }),
    colorScheme: PropTypes.object,
    width: PropTypes.string,
    isDisabled: PropTypes.bool,
    internalLink: PropTypes.any,
    transition: PropTypes.any,
    buttonText: PropTypes.string
  })
};
